import { Link } from 'react-router-dom';
import { HelElement, HelFC } from '../../interfaces';

export const PoolLink: HelFC<{ id:string }> = ({ children, id }): HelElement => (
  <Link to={`/pools/${id}`}>
    {children}
  </Link>
);
